/* unplugin-vue-components disabled */import { render } from "./answer.vue?vue&type=template&id=3c66adfc&scoped=true"
import script from "./answer.vue?vue&type=script&lang=js"
export * from "./answer.vue?vue&type=script&lang=js"

import "./answer.vue?vue&type=style&index=0&id=3c66adfc&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c66adfc"],['__file',"src/components/ai-chat/ai-assistant/answer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c66adfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c66adfc', __exports__)) {
    api.reload('3c66adfc', __exports__)
  }
  
  module.hot.accept("./answer.vue?vue&type=template&id=3c66adfc&scoped=true", () => {
    api.rerender('3c66adfc', render)
  })

}


export default __exports__